import styled from 'styled-components';
// import Image from '@stencil/image';

export const FlexCentered = styled.div(
  props => `
    display:flex;
    align-items:center;
    `,
);

export const PrimaryLink = styled.a(
  props => `
    color:${props.theme.colors.goBrand.blue};
  `,
);

export const GoSafeSearchBlockContainerWrap = styled(FlexCentered)(
  props => `
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    padding: ${props.theme.spacing.base};
    background: ${props.backgroundColor || props.theme.colors.white.base};
    `,
);

export const GoSafeCardHeader = styled.p(
  props => `
  color: ${props.color || props.theme.colors.black.base};
  `,
);

export const GoSafeSearchBlockTextWrap = styled.div(
  props => `
    font-size: ${props.theme.font.large.font16};
    margin-left: ${props.theme.spacing.base};
    `,
);

export const GlobeAlertIconWrap = styled.img(
  props => `
  width:3.4rem;
  height:3.2rem;
  `,
);

export const GoSafeLearnMoreBtn = styled(PrimaryLink)(
  props => `
    color: ${props.color || props.theme.colors.blue.brand};
    margin-left: ${props.theme.spacing.base};
    `,
);

export const GoSafeCasesInfoText = styled.p(
  props => `
    color: ${props.color || props.theme.colors.green.base};
    font-size: ${props.theme.font.large.font14};
    margin-top: ${props.theme.spacing.small};
    `,
);

export const GosafeEarthSaverImg = styled.img(
  props => `
  width: 3rem;
  height: 3rem;
  object-fit: contain;
    `,
);
